import _extends from "@babel/runtime/helpers/extends";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { useMediaQuery } from '@mui/material';
import { EmbersTitle } from '../title/title';
import { EmbersGrid } from '../grid/grid';
import { SKIP_TO_MAIN_CONTENT_ID } from '../header';
import { StyledTemplateContent } from './templateStyles';
import { ErrorContentTemplate } from './errorContent';
import { PROMETHEAN_BREAKPOINT_NAV_CHANGE } from '../styles/breakpoints/breakpoints';
import { EmbersTypography } from '../typography';
export var ContentTemplate = function ContentTemplate(props) {
  var type = props.type,
    _props$pageTitle = props.pageTitle,
    pageTitle = _props$pageTitle === void 0 ? '' : _props$pageTitle,
    titleInfo = props.titleInfo,
    _props$titleProps = props.titleProps,
    titleProps = _props$titleProps === void 0 ? {
      level: 'secondary'
    } : _props$titleProps,
    errorMessage = props.errorMessage,
    errorImage = props.errorImage,
    onBack = props.onBack,
    errorButton = props.errorButton,
    actionItems = props.actionItems,
    pageContent = props.pageContent,
    children = props.children,
    _props$skipTo = props.skipTo,
    skipTo = _props$skipTo === void 0 ? true : _props$skipTo,
    className = props.className,
    id = props.id,
    role = props.role,
    titlePostfix = props.titlePostfix;
  var mobileNavViewPort = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE, "px)"));
  var generateComplexCardTemplate = function generateComplexCardTemplate(content) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, content.map(function (row, i) {
      var numItems = row.rowItems.length;
      return /*#__PURE__*/React.createElement(EmbersGrid, {
        className: "EmbersTemplate-row",
        key: "row-".concat(i),
        container: true
      }, row.rowTitle && /*#__PURE__*/React.createElement(EmbersGrid, {
        className: "EmbersTemplate-rowTitle",
        key: "rowTitle-".concat(i),
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(EmbersTypography, {
        variant: "subtitleA",
        componentType: row.rowHeading || 'h2'
      }, row.rowTitle)), row.rowItems.map(function (item, j) {
        return /*#__PURE__*/React.createElement(EmbersGrid, {
          key: "item-".concat(j),
          item: true,
          xs: 4,
          md: numItems === 1 ? 8 : 4,
          lg: 12 / numItems
        }, item);
      }));
    }));
  };
  var withoutTitle = titleProps.level === 'primary' && mobileNavViewPort && !titleInfo && !actionItems;
  return /*#__PURE__*/React.createElement(StyledTemplateContent, {
    container: true,
    className: classnames('EmbersTemplate-content', "EmbersTemplate-".concat(type), {
      'EmbersTemplate-hasTitlePostfix': !!titlePostfix
    }, className),
    id: skipTo ? SKIP_TO_MAIN_CONTENT_ID : id,
    role: (role !== null && role !== void 0 ? role : skipTo) ? 'main' : undefined
  }, type !== 'error' && (pageTitle || onBack) && /*#__PURE__*/React.createElement(EmbersGrid, {
    item: true,
    xs: 4,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 12,
    sx: {
      paddingTop: withoutTitle ? 3 : 0
    }
  }, titleProps.level === 'primary' && mobileNavViewPort ? !withoutTitle && /*#__PURE__*/React.createElement(EmbersTitle, _extends({
    type: "pageTitle",
    text: titleInfo
  }, titleProps), actionItems) : /*#__PURE__*/React.createElement(EmbersTitle, _extends({
    type: "pageTitle",
    text: pageTitle,
    title: titleInfo,
    onBack: onBack,
    titlePostfix: titlePostfix
  }, titleProps), actionItems)), /*#__PURE__*/React.createElement(EmbersGrid, {
    item: true,
    xs: 4,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 12
  }, type === 'error' ? /*#__PURE__*/React.createElement(ErrorContentTemplate, {
    error: pageTitle,
    errorMessage: errorMessage,
    errorImage: errorImage,
    errorButton: errorButton,
    onBack: onBack
  }) : pageContent ? generateComplexCardTemplate(pageContent) : children));
};